import { computed } from 'vue'
import { useToast } from '@/composables/common/useToast'
import store from '@/store'
import { config } from '@/config.js'

export function useDeportistaPlazos(props, refreshBase) {
    const toast = useToast()

    const configuracion = computed(() => store.getters.getConfig)

    /**
     * Pagar un plazo específico
     */
    async function pagarPlazo(plazo_id, metodo_pago) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            plazo_id: plazo_id,
            filters: {
                tid: configuracion.value.hash_teatro,
                metodo_pago: metodo_pago
            }
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.plazos.pagar'),
                params
            )
            toast.success(res.data.message || 'Plazo pagado correctamente')
            await refreshBase()
        } catch (error) {
            console.error('Error paying plazo:', error)
            toast.error(error.response?.data?.message || 'Error al pagar el plazo')
        }
    }

    /**
     * Pagar todos los plazos
     */
    async function pagarPlazos(metodo_pago) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            filters: {
                tid: configuracion.value.hash_teatro,
                metodo_pago: metodo_pago
            }
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.plazos.pagar-todos'),
                params
            )
            toast.success(res.data.message || 'Todos los plazos pagados correctamente')
            await refreshBase()
        } catch (error) {
            console.error('Error paying plazos:', error)
            toast.error(error.response?.data?.message || 'Error al pagar los plazos')
        }
    }

    /**
     * Descontar un plazo con descuento íntegro o porcentaje
     */
    async function descontarPlazo(descuento_integro, descuento_porcentaje, plazo_id) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            plazo_id: plazo_id,
            filters: {
                tid: configuracion.value.hash_teatro,
                descuento_integro: descuento_integro,
                descuento_porcentaje: descuento_porcentaje
            }
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.plazos.descontar'),
                params
            )
            toast.success(res.data.message || 'Descuento aplicado correctamente')
            await refreshBase()
        } catch (error) {
            console.error('Error applying descuento:', error)
            toast.error(error.response?.data?.message || 'Error al intentar aplicar un descuento')
        }
    }

    /**
     * Generar enlace de pago para un plazo (estado==4)
     */
    async function generarEnlacePago(plazo_id) {
        const params = {
            base_id: props.base_id,
            lista_id: props.lista_id,
            plazo_id: plazo_id
        }

        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.plazos.enviar-url-compra'),
                params
            )
            toast.success(res.data.message || 'Enlace de pago generado correctamente')
            return res.data
        } catch (error) {
            console.error('Error generating payment link:', error)
            toast.error(error.response?.data?.message || 'Error al generar el enlace de pago')
        }
    }

    return {
        pagarPlazo,
        pagarPlazos,
        descontarPlazo,
        generarEnlacePago,
    }
}
